"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastLinkStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const ToastLinkStyled = (0, _styled.default)("a")`
    font-weight: 600;
    cursor: pointer;

    // Elide if the link is too wide. We just need a non-inline type here.
    display: inline-grid;
    // IE11 hack
    display: -ms-inline-flexbox;
    vertical-align: bottom;

    &,
    &:visited {
        color: currentColor;
    }

    text-decoration: underline;

    // Only remove the underline if we're actually going to show a focus ring.
    ${_ref => {
  let {
    focusMode
  } = _ref;
  return focusMode === "keyboard" ? `
                &:focus {
                    text-decoration: none;
                }
            ` : "";
}}
`;
exports.ToastLinkStyled = ToastLinkStyled;
//# sourceMappingURL=ToastLinkStyled.js.map